<template>
    <div id="app"  :class="{'page-auth': !isUserLoaded || needAuth || isBanned || isNoSuccess}">
        <div v-if="!isUserLoaded" class="preloader-page">
            <div class="preloader">preloader</div>
        </div>

        <section class="page-auth__section" v-else-if="needAuth && !isBanned && !isNoSuccess">
            <div class="content content__page-auth">
                <div class="text-center" >
                   <img src="@/assets/img/devz-logo.svg" alt="">
                </div>
                <div class="container mt40">
                    <div class="auth-form-container">
                        <auth v-if="!isBanned && !isNoSuccess"></auth>
                        <auth-error v-else-if="isBanned || isNoSuccess"></auth-error>
                    </div>
                </div>
            </div>
            <div class="footer">
            </div>
        </section>
        <div  v-else-if="isUserLoaded">
            <header class="header">
                <div class="header__top">
                    <div class="inner-wrapper">
                        <div class="h-left">
                            <router-link class="h-logo" to="/">
                                <img src="@/assets/img/devz-logo.svg" alt="">
                            </router-link>
                            <top-menu/>
                        </div>
                        <div class="h-right">
                            <user-tooltip></user-tooltip>
                        </div>
                    </div>
                </div>
            </header>
            <router-view v-if="menuList.length > 0"/>
        </div>
        <popup :show="popups.takeDayOff.show"
                :width="1054"
               :name="popups.takeDayOff.name">
            <take-day-off/>
        </popup>
        <popup :show="popups.leave.show"
                :width="680"
               :name="popups.leave.name">
            <leave/>
        </popup>
        <popup :show="popups.workOvertime.show"
                :width="680"
                :is-btn-close="false"
               :name="popups.workOvertime.name">
            <work-overtime/>
        </popup>
        <popup :show="popups.errorSocket.show"
                :width="480"
               :name="popups.errorSocket.name">
            <error-socket/>
        </popup>

        <div class="timer__popup" v-if="worker.timer && worker.timer.leave.time && worker.userId == user.id">
            <div class="name text-bold">
                {{user.firstName}}
            </div>
            <div class="text-size-xxxl text-bold mt4">
                Уход в рабочее время
            </div>
            <div class="timer mt4">
                {{ worker.timer.leave.time }}
            </div>
            <submit-btn @click="stopLeaveTimer" class="mt16" tag="button" :type="btnType">
                вернуться к работе
            </submit-btn>
        </div>

        <div class="timer__popup" v-if="worker.timer && worker.timer.worked.time && worker.userId == user.id">
            <div class="name text-bold">
                {{user.firstName}}
            </div>
            <div class="text-size-xxxl text-bold mt4">
                Сверхурочная отработка
            </div>
            <div class="timer mt4">
                {{ worker.timer.worked.time }}
            </div>
            <button name="button" class="btn mt16" @click="stopOvertimeTimer">закончить работу</button>
        </div>

        <log v-if="isUserLoaded && !needAuth && !isBanned && !isNoSuccess"></log>
    </div>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import TopMenu from '@/components/TopMenu.vue';
import Auth from '@/components/Auth.vue';
import AuthError from '@/components/AuthError.vue';
import UserTooltip from '@/components/UserTooltip.vue';
import Tooltip from '@/components/Tooltip.vue';
import Popup from '@/components/modal/Popup.vue';
import TakeDayOff from '@/components/modal/TakeDayOff.vue';
import ErrorSocket from '@/components/modal/ErrorSocket.vue';
import Leave from '@/components/modal/Leave.vue';
import WorkOvertime from '@/components/modal/WorkOvertime.vue';
import Log from '@/components/Log.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue';

export default {
    name: "MainSection",
    components: {
        TopMenu,
        Auth,
        AuthError,
        UserTooltip,
        Popup,
        TakeDayOff,
        Leave,
        WorkOvertime,
        Log,
        SubmitBtn,
        ErrorSocket,
    },
    data: function(){
        return {
            logOpen: false,
            btnType: 'normal',
            socketObj: false,
            socketOpen: false,
            socketOpenCount: 0,
        }
    },
    created() {
        //this.$store.dispatch('options/getList');
        this.$store.dispatch('auth/getCurrentUser');
    },
    computed: {
        ...mapState({
            isUserLoaded: state => state.auth.isLoaded,
            user: state => state.auth.user,
            menuList: state => state.menus.itemsTop,
            formAuthFields: state => state.auth.forms.auth.fields,
            isBanned: state => state.auth.isBanned,
            isNoSuccess: state => state.auth.isNoSuccess,
            isNoSuccessSection: state => state.auth.isNoSuccessSection,
            popups: state => state.popups.items,
            localStorage: state => state.auth.localStorage,
            worker: state => state.workers.item,
        }),
        ...mapGetters({
                needAuth:'auth/needAuth',
            }
        ),
        workerTime(){
            let time = {
                hours: '00',
                minutes: '00',
                days: '00',
            }
            let workerTime = this.worker.time;
            if(workerTime < 0){
                workerTime = -workerTime;
            }
            if(workerTime > 0 && workerTime < 60){
                time.hours = '00';
                time.minutes = '01';
            } else if(workerTime > 0){
                time.hours = Math.floor(workerTime / 60 / 60);
                time.minutes = Math.floor(workerTime / 60) - (time.hours * 60);
                if(time.hours < 10){
                    time.hours = '0'+time.hours;
                }
                if(time.minutes < 10){
                    time.minutes = '0'+time.minutes;
                }
            }
            if(this.worker.days < 0){
                time.days = this.worker.days * -1;
            } else {
                time.days = this.worker.days;
            }
            if(time.days < 10){
                time.days = '0'+time.days;
            }

            return time;
        },
    },
    methods: {
        stopLeaveTimer(){
            this.btnType = 'load';
            this.$store.dispatch('workers/leave',{timeType:'end'}).then(()=>{
                this.btnType = 'ok';
            });
        },
        stopOvertimeTimer(){
            this.$store.commit('workers/finishTimer');
            this.$store.dispatch('popups/open', {name: this.popups.workOvertime.name});
        },
    },

    mounted () {

    },
}
</script>
<style>
</style>
